export const BACKEND_URL: string = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8080';
export const PAYMENT_SERVICE_URL: string = import.meta.env.VITE_PAYMENT_SERVICE_URL || 'http://localhost:8083';
export const ADMINISTRATION_SERVICE_URL: string = import.meta.env.VITE_ADMINISTRATION_SERVICE_URL || 'http://localhost:8082';
export const SOCKET_URL_STOMP: string = import.meta.env.VITE_WEBSOCKET_URL || 'ws://localhost:8081/ws';

// export const BACKEND_URL = 'https://staging-backend-service-nwh5q2sygq-ez.a.run.app';
// export const SOCKET_URL_STOMP = 'wss://staging-websocket-service-nwh5q2sygq-ez.a.run.app/ws';
// export const PAYMENT_SERVICE_URL = 'https://staging-payment-service-nwh5q2sygq-ez.a.run.app';
// export const ADMINISTRATION_SERVICE_URL = 'https://staging-administration-service-nwh5q2sygq-ez.a.run.app';
